import React from 'react';
import { Text, keyframes } from '@chakra-ui/react';

const loadingDots = keyframes`
  0% { content: ''; }
  25% { content: '.'; }
  50% { content: '..'; }
  75% { content: '...'; }
  100% { content: ''; }
`;

const LoadingDots = (): JSX.Element => (
  <Text
    as="span"
    sx={{
      '&::after': {
        content: "''",
        animation: `${loadingDots} 1s infinite`,
        display: 'inline-block',
        width: '24px',
      },
    }}
  >
    Thinking
  </Text>
);

export default LoadingDots;
